<template>
    <div class="vue-location-dropdown form-item" v-click-outside="() => { this.open = false }" @keydown.esc="open = false">
        <label for="location-dropdown" :class="{'visually-hidden': hideLabel}">{{ translations.locationDropdownLabel }}</label>

        <div class="input-wrapper">
            <input
                type="search"
                autocomplete="off"
                v-model="value"
                @input="handleChange"
                @focusin="open = true"
                :placeholder="translations.locationSearchPlaceholder"
                id="location-dropdown">

            <aut-geo-locator
                @geo="handleGeo"
                @loading="handleLoading"
                :using-input="usingInput"
            ></aut-geo-locator>
        </div>

        <div class="dropdown-list" v-show-slide="canOpen">
            <template v-if="hasLocations">
                <table class="w-100">
                    <thead>
                    <tr class="vue-location-dropdown-item">
                        <th>Dichtsbijzijnde vestiging</th>
                        <th>Afstand</th>
                    </tr>
                    </thead>

                    <tbody>
                    <aut-location-dropdown-item
                        v-for="location in locations"
                        :key="location.id"
                        :item="location"
                        @clicked="handleLocationClicked"
                    ></aut-location-dropdown-item>
                    </tbody>
                </table>
            </template>

            <template v-if="loading.status">
                <div class="vue-location-dropdown-item">
                    <p class="w-100 mb-0">{{ loading.message }}</p>
                </div>
            </template>

            <template v-if="!hasLocations && !loading.status">
                <div class="vue-location-dropdown-item">
                    <p class="w-100 mb-0">{{ translations.noResultsText }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import DropdownItem from "./DropdownItem";
import translations from "../../mixins/translations";
import lodash from "lodash";
import GeoLocator from "./GeoLocator";

export default {
    name: "Dropdown",

    mixins: [translations],

    components: {
        'aut-location-dropdown-item': DropdownItem,
        'aut-geo-locator': GeoLocator,
    },

    directives: {
        ClickOutside
    },

    props: {
        vehicleId: {
            type: Number|String
        },
        vehicleGroup: {
            type: String
        },
        hideLabel: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            geoLocation: {},
            locations: [],
            value: '',
            loading: {
                status: true,
                message: window.Drupal.t('Trying to get current location..'),
            },
            open: false,
            usingInput: false,
        }
    },

    computed: {
        hasGeoLocation() {
            return !lodash.isEmpty(this.geoLocation);
        },

        hasLocations() {
            return !lodash.isEmpty(this.locations);
        },

        canOpen() {
            return !lodash.isEmpty(this.value) && this.open || this.open && this.hasLocations;
        }
    },

    methods: {
        handleChange() {
            this.loading = {
                status: true,
                message: this.translations.loadingText,
            };
            this.$emit('input-value', this.value);
            this.usingInput = true;
            this.geoCode();
        },

        geoCode: lodash.debounce(function () {
            this.$geocoder.send({
                address_line_1: this.value
            }, response => {
                if (response.status !== 'OK') {
                    this.locations = [];

                    this.loading = {
                        status: false,
                    };

                    return;
                }

                this.geoLocation = lodash.first(response.results).geometry.location;
                this.fetchLocations();
            });
        }, 300),

        fetchLocations() {
            let url = `/api/locations?lat=${this.geoLocation.lat}&lng=${this.geoLocation.lng}`;

            if (!lodash.isNil(this.vehicleId)) {
                url = url.concat(`&vehicleId=${this.vehicleId}`);
            }

            if (!lodash.isNil(this.vehicleGroup)) {
                url = url.concat(`&vehicleGroup=${this.vehicleGroup}`);
            }

            axios.get(url)
                .then(response => {
                    if (response.status !== 200) {
                        this.locations = [];
                        return;
                    }

                    this.locations = response.data;
                })
                .catch(error => {
                    this.locations = [];
                })
                .finally(() => this.loading = {status: false});
        },

        handleLocationClicked(value) {
            this.open = false;
            this.value = value.place;
            this.$emit('active-location', value);
        },

        handleGeo(payload) {
            this.geoLocation = payload.payload;
            this.usingInput = false;
            this.fetchLocations();
            this.handleLoading(false)
        },

        handleLoading(payload) {
            this.loading.status = payload;
        }
    }
}
</script>
